module.exports = __webpack_public_path__ + "static/media/Visa.8ab0a320.svg";